import React from "react";
import { useTranslation } from "react-i18next";
import Navbar from "../components/Navbar";

const TransparentCard = ({ image, title }) => {
  return (
    <div className="bg-white/50 backdrop-blur-sm border rounded-lg shadow-lg overflow-hidden transition duration-300 hover:bg-white/90">
      <img src={image} alt={title} className="w-full h-64 object-cover" />
      <p className="p-4 text-center font-semibold text-black/90">{title}</p>
    </div>
  );
};

const Certificates = () => {
  const { t } = useTranslation();
  const certificates = ["certificate1.jpg", "certificate2.jpg", "certificate3.jpg"];

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Navbar className="bg-black/60 backdrop-blur-md fixed top-0 w-full z-50" />
      <div className="pt-28 p-6 max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center">{t("certificates.title")}</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {certificates.map((img, i) => (
            <TransparentCard
              key={i}
              image={`/documents/certificates/${img}`}
              title={t("certificates.imageLabel", { number: i + 1 })}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Certificates;
